module.exports = "/img/facobook_logo.png?4a5c8df219ae3cf06e65eb325cee986b";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/facobook_logo.png
// module id = uPOe
// module chunks = 66